import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import CardLayout from "../../common/cardLayout/CardLayout";
import InfoIcon from "../../../assets/icons/info.svg";
import { ReactComponent as RightArrow } from "../../../assets/icons/right-arrow.svg";
import RedFlag from "../../../assets/icons/red-flag.svg";
import YellowFlag from "../../../assets/icons/yellow-flag.svg";
import "./DashboardStyles.css";
import LinkButton from "../../common/LinkButton";
import RiskPill from "../../common/RiskPill";
import { CTooltip } from "@coreui/react";
import PrimaryHeader from "../../common/primaryHeader/PrimaryHeader";
import { useSelector, useDispatch } from "react-redux";
import {
  invitedPatientLogic,
  patientLogic,
} from "../../../store/features/patient/patientSlice";
import PatientLoader from "../../common/PatientLoader";
import moment from "moment";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import { ReactComponent as NoPatientsIcon } from "../../../assets/images/EmptyPatients.svg";
import {
  getStaffLogic,
  setFirstLoad,
} from "../../../store/features/app/appSlice";
import { Helmet } from "react-helmet";
import DummyClient from "../chat/DummyClient";
import {
  getChatEnabledPatientsLogic,
  getChatHistoryLogic,
} from "../../../store/features/chat/chatSlice";
import { isEmptyObject } from "jquery";

const PatientItem = ({ patientData, type, show_pill = false }) => {
  const navigate = useNavigate();
  return (
    <tr
      className="py-3"
      style={{
        height: "4rem",
        verticalAlign: "middle",
      }}
    >
      <td>
        <small style={{ fontWeight: "500", textTransform: "capitalize" }}>
          {patientData?.first_name} {patientData?.last_name}
        </small>
      </td>
      <td style={{ width: "25%" }}>
        {show_pill ? <RiskPill type={type} /> : <></>}
      </td>
      <td>
        <small style={{ fontWeight: "500" }}>
          {patientData?.last_active
            ? moment(patientData?.last_active).format("MMM Do YYYY, h:mma")
            : null}
        </small>
      </td>
      <td>
        <button
          onClick={() => {
            navigate(`/patients/${patientData?.id}`);
          }}
          className="primary-btn-small"
          style={{ padding: "0px !important" }}
        >
          View
        </button>
      </td>
    </tr>
  );
};
const PatientTable = ({ patientData, type }) => {
  patientData.sort((a, b) => {
    const dateA = new Date(a.last_active);
    const dateB = new Date(b.last_active);
    return dateB - dateA; // Compare in descending order
  });
  return (
    <table className="table my-3 px-2">
      <thead className="thead-light" style={{ backgroundColor: "#F9FAFB" }}>
        <tr
          style={{
            height: "4rem",
            verticalAlign: "middle",
          }}
        >
          <th scope="col">
            <span className="muted-text">NAME</span>
          </th>
          <th scope="col">
            <span className="muted-text">STATUS</span>
          </th>
          <th scope="col">
            <span className="muted-text">LAST LOGIN</span>
          </th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        {patientData?.map((patient) => {
          return (
            <PatientItem
              patientData={patient}
              key={patient.id}
              type={patient?.fire_flag?.length > 0 ? "urgent" : type}
              show_pill={patient?.fire_flag?.length > 0}
            />
          );
        })}
      </tbody>
    </table>
  );
};

export const InfoCard = ({
  title,
  stats,
  information,
  button_text,
  button_link,
  handleNavigation,
  show_link = true,
  style = {},
}) => {
  return (
    <div className="info-card" style={style}>
      <div className="d-flex justify-content-between my-2">
        <h6
          className="info-card-title"
          style={{ color: style?.color ? style?.color : "#64748b" }}
        >
          <strong>{title}</strong>
        </h6>
        <CTooltip content={information}>
          <img
            style={{ cursor: "pointer" }}
            src={InfoIcon}
            height="15px"
            width="15px"
            alt="Information Icon"
          />
        </CTooltip>
      </div>
      <h3
        className="primary-text pb-2"
        style={{
          textAlign: "start",
          color: style?.color ? style?.color : "#333",
        }}
      >
        {stats}
      </h3>
      {show_link && (
        <button
          onClick={() => {
            handleNavigation(button_link);
          }}
          className="link-button mb-2"
        >
          <small>{button_text}</small>
          <RightArrow
            src={RightArrow}
            alt=">"
            style={{
              marginLeft: "10px",
              marginTop: "2px",
              fill: "#b5c3cb",
              stroke: "#b5c3cb",
            }}
            height={"14px"}
            width={"14px"}
          />
        </button>
      )}
    </div>
  );
};

export const NoPatients = ({ text }) => {
  return (
    <div className="container-fluid text-center my-5">
      <NoPatientsIcon width={100} height={100} />
      <div className="container-fluid text-center mt-2">
        <span
          style={{ display: "block", color: "#093652", fontWeight: "bold" }}
        >
          {text}
        </span>
      </div>
    </div>
  );
};
const DashboardHome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const patient = useSelector((state) => state.patient);
  const { user, selectedClinic, firstLoad, selectedProvider } = useSelector(
    (state) => state.app
  );
  const handleNavigation = (navigate_to) => {
    navigate(navigate_to);
  };

  useEffect(() => {
    if (!selectedClinic || isEmptyObject(selectedClinic)) {
      handleNavigation("/dashboard/select-clinic/");
    }
    console.log("user: ", user);
    console.log("selectedProvider: " + selectedProvider);
    let userId = user?.id;
    if (selectedProvider) {
      userId = selectedProvider;
    }
    console.log("userId: " + userId);
    dispatch(
      patientLogic({
        page_size: 999999,
        page: 1,
        clinic_id: selectedClinic?.clinic?.id,
        clinician_id: userId,
      })
    );
    dispatch(
      getChatHistoryLogic({
        page_size: "9999999",
        clinic_id: selectedClinic?.clinic?.id,
        clinician_id: userId,
      })
    );
    dispatch(
      getChatEnabledPatientsLogic({
        clinic_id: selectedClinic?.clinic?.id,
        clinician_id: userId,
      })
    );

    //TODO: Change the patientLogic Django API to send invited patients as well to remove this API call.
    dispatch(
      invitedPatientLogic({
        page_size: 999999,
        page: 1,
        status: "INVITED",
        clinic_id: selectedClinic?.clinic?.id,
        clinician_id: userId,
      })
    );

    dispatch(getStaffLogic());
    dispatch(setFirstLoad({ status: false }));
  }, []);
  return (
    <SidebarLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Dashboard | Precise Digital</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <section className="container-fluid">
        {/* <DummyClient /> */}
        <PrimaryHeader
          titleText={`Hi ${user?.first_name} ${user?.last_name},`}
          subTitleText="See how your patients are doing..."
          showSubtitle={true}
        />
        {patient?.loading || firstLoad ? (
          <PatientLoader />
        ) : (
          <>
            <div
              className="container-fluid px-1 py-4 row"
              style={{ margin: "0px" }}
            >
              <div
                className="col-sm-12 col-md-3 col-lg-3"
                style={{ margin: "0px", padding: "0px" }}
              >
                <InfoCard
                  title={"All Patients"}
                  button_link={"/patients/all/"}
                  button_text={"View All Patients"}
                  stats={patient?.patientCount || 0}
                  information={"View all patient records"}
                  handleNavigation={handleNavigation}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3">
                <InfoCard
                  title={"Inactive Patients"}
                  button_link={"/patients/inactive/"}
                  button_text={"View Patients"}
                  stats={patient?.inActivePatient?.length || 0}
                  information={"View all inactive patient records"}
                  handleNavigation={handleNavigation}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3">
                <InfoCard
                  title={"BHI Eligible Patients"}
                  button_link={"/patients/bhi?status=eligible"}
                  button_text={"View Patients to Enroll"}
                  stats={patient?.bhiEligiblePatient?.length || 0}
                  information={
                    "BHI-eligible patients are those who meet the requirements for Behavioral Health Integration services, based on their clinical assessment results administered via the Precise Digital app."
                  }
                  handleNavigation={handleNavigation}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3">
                <InfoCard
                  title={"New Patients"}
                  button_link={"/patients/new/"}
                  button_text={"View New Patients"}
                  stats={patient?.newPatient?.length || 0}
                  information={"View all new patient records"}
                  handleNavigation={handleNavigation}
                />
              </div>
            </div>
            <div
              className="container-fluid px-1 py-4"
              style={{ margin: "0px" }}
            >
              <strong
                style={{ fontSize: "1.2rem" }}
                className="strong-title-text"
              >
                FLAGGED PATIENTS
              </strong>
              <div className="row mt-4">
                <CardLayout
                  className="col-sm-12 col-md-6 col-lg-6"
                  style={{
                    border: "5px solid transparent",
                    boxSizing: "border-box",
                    backgroundClip: "padding-box",
                  }}
                >
                  <div className="container-fluid">
                    <div className="d-flex justify-content-between my-3">
                      <div className="d-flex" style={{ gap: "15px" }}>
                        <img
                          src={RedFlag}
                          height="16px"
                          width="16px"
                          alt="Red Flag"
                        />
                        <h6 className="info-card-title">
                          <strong style={{ fontSize: "1.2rem" }}>
                            Red Alert Patients (
                            {patient?.redPatient?.length || 0})
                          </strong>
                        </h6>
                        <CTooltip
                          content={
                            "Patients that have been identified as a potential urgent risk alert, which means the Precise Digital system has detected indications of harm"
                          }
                        >
                          <img
                            style={{ cursor: "pointer" }}
                            src={InfoIcon}
                            height="16px"
                            width="16px"
                            alt="Information Icon"
                          />
                        </CTooltip>
                      </div>
                      <small>
                        <Link
                          to="/patients/all?flag=red"
                          style={{
                            textDecoration: "underline",
                            color: "#3893CC",
                            fontWeight: "bold",
                          }}
                        >
                          {patient?.redPatient?.length > 0 && "View All"}
                        </Link>
                      </small>
                    </div>

                    {patient?.redPatient &&
                      patient?.redPatient?.length === 0 && (
                        <NoPatients
                          text={"There are no patients with Red Alert"}
                        />
                      )}
                    {patient?.redPatient && patient?.redPatient?.length > 0 && (
                      <>
                        <PatientTable
                          patientData={patient?.redPatient
                            ?.slice()
                            ?.sort((a, b) => {
                              const dateA = new Date(a.last_active);
                              const dateB = new Date(b.last_active);
                              return dateB - dateA; // Compare in descending order
                            })
                            ?.slice(0, 5)}
                          type="urgent"
                        />
                        <br />
                        <div className="container-fluid mb-4 w-100">
                          <LinkButton
                            callback={() => {
                              handleNavigation("/patients/all?flag=red");
                            }}
                            styles={{ color: "#093652", fontWeight: 500 }}
                            text={"View All Red Alert Patients"}
                            icon={
                              <RightArrow
                                src={RightArrow}
                                alt=">"
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "2px",
                                  stroke: "#093652",
                                }}
                                height={"14px"}
                                width={"14px"}
                              />
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                </CardLayout>
                <CardLayout
                  className="col-sm-12 col-md-6 col-lg-6"
                  style={{
                    border: "5px solid transparent",
                    boxSizing: "border-box",
                    backgroundClip: "padding-box",
                  }}
                >
                  <div className="container-fluid">
                    <div className="d-flex justify-content-between my-3">
                      <div className="d-flex" style={{ gap: "20px" }}>
                        <img
                          src={YellowFlag}
                          height="16px"
                          width="16px"
                          alt="Yellow Flag"
                        />
                        <h6 className="info-card-title">
                          <strong style={{ fontSize: "1.2rem" }}>
                            Yellow Alert Patients (
                            {patient?.yellowPatient?.length || 0})
                          </strong>
                        </h6>
                        <CTooltip
                          content={
                            "Patients that have been identified as a potential risk alert, which means the Precise Digital system has detected indications of mental distress"
                          }
                        >
                          <img
                            style={{ cursor: "pointer" }}
                            src={InfoIcon}
                            height="16px"
                            width="16px"
                            alt="Information Icon"
                          />
                        </CTooltip>
                      </div>
                      <small>
                        <Link
                          to="/patients/all?flag=yellow"
                          style={{
                            textDecoration: "underline",
                            color: "#3893CC",
                            fontWeight: "bold",
                          }}
                        >
                          {patient?.yellowPatient?.length > 0 && "View All"}
                        </Link>
                      </small>
                    </div>
                    {patient?.yellowPatient &&
                      patient?.yellowPatient?.length === 0 && (
                        <NoPatients
                          text={"There are no patients with Yellow Alert"}
                        />
                      )}
                    {patient?.redPatient &&
                      patient?.yellowPatient?.length > 0 && (
                        <>
                          <PatientTable
                            patientData={patient?.yellowPatient
                              ?.slice()
                              ?.sort((a, b) => {
                                const dateA = new Date(a.last_active);
                                const dateB = new Date(b.last_active);
                                return dateB - dateA; // Compare in descending order
                              })
                              ?.slice(0, 5)}
                            type={"medium"}
                          />
                          <br />
                          <div className="container-fluid mb-4 w-100">
                            <LinkButton
                              callback={() => {
                                handleNavigation("/patients/all?flag=yellow");
                              }}
                              styles={{ color: "#093652", fontWeight: 500 }}
                              text={"View All Yellow Alert Patients"}
                              icon={
                                <RightArrow
                                  src={RightArrow}
                                  alt=">"
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "2px",
                                    stroke: "#093652",
                                  }}
                                  height={"14px"}
                                  width={"14px"}
                                />
                              }
                            />
                          </div>
                        </>
                      )}
                  </div>
                </CardLayout>
              </div>
            </div>
            <div style={{ height: "20vh" }} />
          </>
        )}
      </section>
    </SidebarLayout>
  );
};

export default DashboardHome;
